"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Removes a clause from the rules edit page
 * @param clauseId the id of the clause to remove
 * @param sectionType the section that the clause belongs to (action, conditional, exception)
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default.inboxRulesEditState; },
})(legacy_1.action('removeClause')(function removeClause(clauseId, sectionType, state) {
    var optionState = state.optionState;
    optionState.clauseMap.delete(clauseId);
    if (sectionType == 'conditional') {
        var indexToDelete = optionState.conditionalClauseIds.indexOf(clauseId);
        optionState.conditionalClauseIds.splice(indexToDelete, 1);
    }
    else if (sectionType == 'action') {
        var indexToDelete = optionState.actionClauseIds.indexOf(clauseId);
        optionState.actionClauseIds.splice(indexToDelete, 1);
    }
    else if (sectionType == 'exception') {
        var indexToDelete = optionState.exceptionClauseIds.indexOf(clauseId);
        optionState.exceptionClauseIds.splice(indexToDelete, 1);
    }
    else {
        throw new Error('Cannot remove clause in section type that does not exist');
    }
}));
//# sourceMappingURL=removeClause.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/removeClause.js
// module id = 5202
// module chunks = 2